import {Button, Card} from "react-bootstrap";

import {t} from "i18next";
import useDetailsAction from "@main/configurations/actions/details/useDetailsAction";
import {useEffect} from "react";

function ConfigurationDetailsPage() {

    const { getFunction, actionTemplate, onSubmitFunction } = useDetailsAction(1);

    useEffect(() => {
        getFunction(1);
    }, []);

    return (
        <Card>
            <Card.Header>
                <Card.Title>{t('configurations')}</Card.Title>
            </Card.Header>

            <Card.Body>
                {actionTemplate}
            </Card.Body>

            <Card.Footer>
                <Button variant="primary" onClick={onSubmitFunction}>
                    {t('save_changes')}
                </Button>
            </Card.Footer>
        </Card>
    );
}

export default ConfigurationDetailsPage;
